const styles = {
    librosDevueltosGrid: {
        borderRight: { xs: "none", xl: "1px solid #D9D9D9" },
        borderLeft:  { xs: "none", xl: "1px solid #D9D9D9" },
        mt:          { xs: 8,      xl: 0 }
    }
}

export default styles;